import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Drawer, IconButton, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/erasmuslogo.jpeg';
import '../style/Navbar.css';

export const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  return (
    <div className="navbar">
      <div className="main">
        {/* Logo */}
        <Link to="/">
          <img src={logo} alt="Erasmus Logo" />
        </Link>

        {/* Masaüstü cihazlar için bağlantılar */}
        <div className="mainLink">
          <Link to="/">Anasayfa</Link>
          <Link to="/about">Hakkımızda</Link>
          <Link to="/contact">İletişim</Link>
          <Link to="/Gallery">Resim Galerisi</Link>
          <Link to="/BasindaBiz">Basında Biz</Link>
          <Link to="/FlipBookViewer">E-dergi</Link>
          <Link to="/ContestPage">Yarişma</Link>
          <Link to="/EylemPlani">Eylem Planı</Link>
          
          
        </div>

        {/* Mobil cihazlar için menü simgesi */}
        <IconButton
          className="menuIcon"
          edge="start"
          aria-label="menu"
          onClick={toggleDrawer(true)}
        >
          <MenuIcon />
        </IconButton>

        {/* Yan çekmece */}
        <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
          <List>
            <ListItem button onClick={toggleDrawer(false)}>
              <Link to="/"><ListItemText primary="Anasayfa" /></Link>
            </ListItem>
            <ListItem button onClick={toggleDrawer(false)}>
              <Link to="/about"><ListItemText primary="Hakkımızda" /></Link>
            </ListItem>
            <ListItem button onClick={toggleDrawer(false)}>
              <Link to="/contact"><ListItemText primary="İletişim" /></Link>
            </ListItem>
            <ListItem button onClick={toggleDrawer(false)}>
              <Link to="/Gallery"><ListItemText primary="Resim Galerisi" /></Link>
            </ListItem>
            <ListItem button onClick={toggleDrawer(false)}>
              <Link to="/BasindaBiz"><ListItemText primary="Basında Biz" /></Link>
            </ListItem>
            <ListItem button onClick={toggleDrawer(false)}>
              <Link to="/FlipBookViewer"><ListItemText primary="E-Dergi" /></Link>
            </ListItem>
            <ListItem button onClick={toggleDrawer(false)}>
              <Link to="/ContestPage"><ListItemText primary="Yarışma" /></Link>
            </ListItem>
            <ListItem button onClick={toggleDrawer(false)}>
              <Link to="/EylemPlani"><ListItemText primary="Eylem Planı" /></Link>
            </ListItem>
           
            
          </List>
        </Drawer>
      </div>
    </div>
  );
};
